<div class="feed">
  <header class="feed-header">
    <h1>Ideas Hub</h1>
    <p class="subtitle">Browse, share, and collaborate on ideas to improve Master Team.</p>
  </header>

  <section *ngIf="latestChallenge" class="challenge-spotlight" aria-label="Challenge spotlight">
    <div class="challenge-card">
      <div class="challenge-header">
        <span class="challenge-label">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94.63 1.5 1.98 2.63 3.61 2.96V19H7v2h10v-2h-2v-3.1c1.63-.33 2.98-1.46 3.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2z"/></svg>
          Challenge Spotlight
        </span>
        <span class="challenge-deadline">Deadline: {{ formatChallengeDeadline(latestChallenge.deadlineUtc) }}</span>
      </div>
      <h3 class="challenge-title">{{ latestChallenge.title }}</h3>
      <p class="challenge-desc">{{ latestChallenge.overview }}</p>
      <a [routerLink]="['/submit-idea']" [queryParams]="{ challengeId: latestChallenge.id }" class="challenge-cta">Submit to Challenge • {{ latestChallenge.points }} points</a>
    </div>
  </section>

  <section class="ideas-section">
    <div class="ideas-tabs">
      <button type="button" class="tab" [class.active]="feedTab === 'all'" (click)="setFeedTab('all')">All</button>
      <button type="button" class="tab" [class.active]="feedTab === 'trending'" (click)="setFeedTab('trending')">Trending</button>
      <button type="button" class="tab" [class.active]="feedTab === 'newest'" (click)="setFeedTab('newest')">Newest</button>
      <button type="button" class="tab" [class.active]="feedTab === 'under-review'" (click)="setFeedTab('under-review')">Under Review</button>
      <button type="button" class="tab" [class.active]="feedTab === 'delivered'" (click)="setFeedTab('delivered')">Delivered</button>
    </div>

    <div class="ideas-filters">
      <input
        class="filter-input"
        type="search"
        placeholder="Search ideas..."
        [ngModel]="searchText"
        (ngModelChange)="onSearchTextChange($event)"
      />
      <select class="filter-select" [ngModel]="categoryFilter" (ngModelChange)="onCategoryFilterChange($event)">
        <option value="">All Categories</option>
        <option *ngFor="let c of (categories.length ? categories : staticCategoryOptions)" [value]="c.id || c.value">{{ c.name || c.label }}</option>
      </select>
      <select class="filter-select" [ngModel]="statusFilter" (ngModelChange)="onStatusFilterChange($event)">
        <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <select class="filter-select" [ngModel]="scopeFilter" (ngModelChange)="onScopeFilterChange($event)">
        <option *ngFor="let opt of scopeOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <select class="filter-select" [ngModel]="effortFilter" (ngModelChange)="onEffortFilterChange($event)">
        <option *ngFor="let opt of effortOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <select class="filter-select" [ngModel]="departmentFilter" (ngModelChange)="onDepartmentFilterChange($event)">
        <option *ngFor="let opt of departmentOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div *ngIf="errorMessage" class="error-banner" role="alert">{{ errorMessage }}</div>
    <div *ngIf="loading" class="loading-state">
      <app-loader label="Loading ideas"></app-loader>
    </div>

    <div *ngIf="!loading && !errorMessage && ideas.length === 0" class="empty-state">
      <p>No ideas yet. Be the first to submit one!</p>
      <a routerLink="/submit-idea" class="btn-primary">Submit Idea</a>
    </div>

    <div class="ideas-list" *ngIf="!loading && ideas.length > 0">
      <article *ngFor="let idea of ideas" class="idea-card">
        <div [routerLink]="['/ideas', idea.id]" class="clickable-card">
        <h3 class="idea-title">
          <p>{{ idea.title }}</p>
        </h3>
        <p *ngIf="idea.description" class="idea-description">{{ idea.description }}</p>
        <div class="idea-tags">
          <span class="tag tag-category">{{ idea.category.name }}</span>
          <span *ngIf="idea.challengeTitle" class="tag tag-challenge">{{ idea.challengeTitle }}</span>
          <span class="tag" [ngClass]="getStatusClass(idea.status)">{{ getStatusLabel(idea.status) }}</span>
        </div>
        <div class="idea-footer">
          <div class="idea-meta">
            <span class="idea-submitter">
              <svg class="meta-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
              {{ idea.ownerDisplayName || 'Anonymous' }}{{ idea.departmentName ? ' • ' + idea.departmentName : '' }}
            </span>
          </div>
          <div class="idea-engagement">
            <span class="engagement-item"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg> {{ getUpvoteCount(idea) }}</span>
            <span class="engagement-item"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"/></svg> {{ getDownvoteCount(idea) }}</span>
            <span class="engagement-item"><svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"/></svg> {{ getCommentCount(idea) }}</span>
            <span class="engagement-item engagement-favorite" [class.favorited]="idea.isFollowing" [title]="idea.isFollowing ? 'Favorited' : 'Not favorited'">
              <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>
            </span>
          </div>
        </div>
      </div>
      </article>
    </div>

    <div *ngIf="!loading && totalCount > pageSize" class="pagination">
      <button type="button" class="btn-secondary" [disabled]="page <= 1" (click)="previousPage()">Previous</button>
      <span class="page-info">Page {{ page }} of {{ totalPages }}</span>
      <button type="button" class="btn-secondary" [disabled]="page * pageSize >= totalCount" (click)="nextPage()">Next</button>
    </div>
  </section>
</div>
